var $$ = $$ || {};

$$.Header = class Header {
	constructor (root) {
		this.root = root;
		this.additionalClass = '';
		this.searchInputDefaultClass = '';
		this.isOpened = false;
		this.currentName = '';

		this.allClasses = {};
		this.tabStates = {};

		this.options = {
			duration: 300,
			defaultHeight: 61,
			easing: 'swing'
		};

		this.oldHeight = this.options.defaultHeight;
		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			listItems: this.root.find('.js-list-item'),
			closeIcons: this.root.find('.js-close-icon'),
			searchInput: this.root.find('.js-search-input'),
			clearableInputs: this.root.find('.js-clearable-input'),
			cityItems: this.root.find('.js-city-item'),
			cityLinks: this.root.find('.js-city-link'),
			contentInner: this.root.find('.js-content-inner'),
			overlay: $('.js-header-overlay'),
			cityNameInHeader: this.root.find('.js-city-name-in-header'),
			menuSearchInput: $('.js-menu-search'),
			forms: this.root.find('.feedback-form form')
		};
	}

	_bindEvents () {
		this.nodes.listItems.on('click', (event) => {
			if (!$(event.currentTarget).hasClass('active')) {
				this._toggleMenu($(event.currentTarget));
			}

			return false;
		});

		$$.body.on('openfeedback', (event) => {
			event.preventDefault();

			this._toggleMenu(this.nodes.listItems.filter('.js-feedback'));
		});

		this.nodes.closeIcons.on('click', () => {
			this._closeHeader();
		});

		this.nodes.searchInput
			.on('input', () => {
				this._inputHandler();
			})
			.on('keypress', (event) => {
				if ( event.keyCode === 13 ) {// enter
					var maxIndex = this.nodes.cityItems.length - 1;
					var lastIndex = 0;

					$(this.nodes.cityItems).each((index, event) => {
						lastIndex = index;

						if ( !$(event).hasClass('letter') && !$(event).hasClass('hidden') ) {
							$(event).children('.js-city-link').trigger("click");

							return false;
						}
					});

					if ( lastIndex === maxIndex ) {
						this.nodes.searchInput.val('');
						this._inputHandler();

						return false;
					}
				}
			});

		this.root.on('click', (event) => {
			event.stopPropagation();
		});

		this.nodes.overlay.on('click', () => {
			this._closeHeader();
		});

		this.nodes.cityLinks.on('click', (event) => {
			var currentCity = $(event.currentTarget);

			if (currentCity.hasClass('disabled') || currentCity.hasClass('letter')) {
				return false;
			}

			this._citySelect(currentCity);

			//return false;
		});

		$$.window.on('keydown', (event) => {
			if (event.keyCode !== $$.ESCAPE_KEY_CODE) {
				return;
			}

			this._closeHeader();
		});

		this.nodes.menuSearchInput.on('focus', () => {
			this._closeHeader();
		});

		this.nodes.forms.each((index, element) => {
			$(element).validate({
				submitHandler: (form) => {
					form = $(form);

					$.ajax({
						url:     form.attr('action'),
						method:  form.attr('method'),
						data:    form.serialize(),
						success: (response) => {
							response = $.parseJSON(response);

							if (response.success) {
								this._closeHeader();
								$$.Noty[ 'successMessage' ](response.success);
								this.root.trigger('headerFormSubmit');
							} else {
								_.each(response.errors, function (value, key) {
									var input = form.find(`input[name="${key}"]`).addClass('error');
									var error = $('<label class="error">' + value + '</label>');

									error.insertAfter(input);
								});
							}
						}
					});
				}
			});
		});
	}

	_ready () {
		this.iconSpace = -7;

		this.currentCity = this.nodes.cityItems.filter((index, city) => {
			return $(city).hasClass('disabled');
		}).first();
	}

	_calculateScrollWidth () {
		return $$.body.get(0).scrollHeight > $$.body.height() ? 20 : 0;
	}

	_citySelect (currentCity) {
		var cityName = currentCity.text();

		this.nodes.cityNameInHeader.text(cityName);
		this.currentCity.removeClass('disabled');
		this.currentCity = currentCity;
		this.currentCity.addClass('disabled');
		this._closeHeader();
	}

	_closeHeader () {
		this.nodes.clearableInputs.val('');
		this.currentName = '';
		this._dropSearchState();
		this.nodes.overlay.removeClass('show');

		this.nodes.overlay.fadeOut();

		this.root.animate({
			height: this.options.defaultHeight
		}, this.options.duration, this.options.easing, () => {
			this.oldHeight = this.options.defaultHeight;
			this.isOpened = false;

			_.forEach(this.allClasses, (state) => {
				this.root.removeClass(state);
			});
		});
	}

	_dropSearchState () {
		if (!this.root.hasClass(this.root.data('searchCity'))) {
			return;
		}

		this.nodes.searchInput.val('');
		this.root.removeClass(this.root.data('searchCity'));
		this.nodes.cityItems.removeClass('hidden');
	}

	_inputHandler () {
		if (!this.searchInputDefaultClass) {
			this.searchInputDefaultClass = this.additionalClass;
		}

		var searchData = this.nodes.searchInput.val().toLowerCase();

		if (searchData) {
			this.root.removeClass(this.additionalClass);
			this.additionalClass = this.root.data('searchCity');
			this.root.addClass(this.additionalClass);

			this.nodes.cityItems.removeClass('hidden');
			this.root.stop();

			this.nodes.cityItems.filter((index, element) => {
				var cityItem = $(element);
				var cityItemName = cityItem.text().toLowerCase();
				var isValidStart = !_.startsWith(cityItemName, searchData);
				var isValidLetter = cityItem.hasClass('letter') && _.first(searchData) === cityItemName;

				return isValidStart && !isValidLetter;
			}).addClass('hidden');
		} else {
			this.root.removeClass(this.additionalClass);
			this.additionalClass = this.searchInputDefaultClass;
			this.root.addClass(this.additionalClass);

			this.nodes.cityItems.removeClass('hidden');
		}

		let oldHeight = this.root.height();

		this.root.css({ height: 'auto' });

		let realHeight = this.root.height();

		this.root.css({ height: oldHeight });

		this.root.animate({
			height: realHeight
		}, this.options.duration);
	}

	_toggleMenu (listItem) {
		var currentName = _.trim(listItem.text());
		var currentAdditionalClass = this.additionalClass;
		var additionalClass = listItem.data('for');
		var scrollWidth = this._calculateScrollWidth();

		if (currentName === this.currentName) {
			this._closeHeader();
			return;
		}

		this.nodes.closeIcons.css({ right: this.iconSpace + scrollWidth });
		this.allClasses[additionalClass] = additionalClass;
		this._dropSearchState();
		this.currentName = currentName;

		if (!listItem.hasClass('js-tab')) {
			currentAdditionalClass = additionalClass;
		} else {
			this.nodes.listItems.removeClass('active');
			listItem.addClass('active');
		}

		if ((!listItem.hasClass('js-tab') && !(currentAdditionalClass in this.tabStates))
			|| listItem.hasClass('js-tab')) {
			this.tabStates[currentAdditionalClass] = additionalClass;
		}

		_.forEach(this.allClasses, (state) => {
			this.root.removeClass(state);
		});

		this.additionalClass = currentAdditionalClass;
		this.root.addClass(this.tabStates[this.additionalClass]);
		this.root.css({ height: 'auto' });

		var endHeight = this.root.height();

		this.root.css({ height: this.oldHeight });

		if (!this.isOpened) {
			this.nodes.overlay.fadeIn();
		}

		this.root.animate({
			height: endHeight
		}, this.options.duration, 'swing', () => {
			this.oldHeight = endHeight;
			this.isOpened = true;
		});
	}
};
